import type { ISignupLocale } from '@/Pages/Onboard/SignUp/Locale/Signup.locale';

const enUS: ISignupLocale = {
  title: 'Create your {brand} account',
  subtitle: 'Join us and start your journey with powerful analytics.',
  firstName: {
    label: 'First Name',
    placeholder: 'Enter your first name',
    error: 'First name is required',
  },
  lastName: {
    label: 'Last Name',
    placeholder: 'Enter your last name',
    error: 'Last name is required',
  },
  email: {
    label: 'Email Address',
    placeholder: 'Enter your email address',
    error: 'Email address is required',
    invalidError: 'Please enter a valid email address',
  },
  password: {
    label: 'Password',
    placeholder: 'Create a strong password',
    error:
      'Password must be at least 8 characters with uppercase, lowercase, number, and special character',
    validationTitle: 'The password must contain:',
    validationMinLength: 'At least 8 characters',
    validationUppercase: 'At least one uppercase letter',
    validationLowercase: 'At least one lowercase letter',
    validationNumber: 'At least one number',
    validationSpecialChar: 'At least one special character',
  },
  confirmPassword: {
    label: 'Confirm Password',
    placeholder: 'Confirm your password',
    error: 'Please confirm your password',
    mismatchError: 'Passwords do not match',
  },
  button: {
    signup: 'Create Account',
    signingUp: 'Creating Account...',
  },
  terms: {
    prefix: 'By creating an account, you agree to our',
    terms: 'Terms of Service',
    and: 'and',
    privacy: 'Privacy Policy',
    suffix: '.',
  },
  success: {
    title: 'Account created successfully!',
    message: 'Welcome to Sonarprint! Please check your email to verify your account.',
  },
  backToLogin: {
    text: 'Already have an account? Sign in',
    link: 'Sign in',
  },
};

export { enUS };
